import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Text } from '../../../shared/uiComponents';
import { useScreenWidth } from '../../../shared/Helpers/hooks';
import { Container } from '../../../components/StyledComponents';
import DefaultBCBA from './defaultBCBA';
import SaveChanges from './saveChanges';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { getClient } from '../../../redux/State/clientSlice/clientSlice';
import { getTherapists } from '../../../redux/State/clientSlice/userClientSlice';
import ProviderLists from './providerLists';
import AccordionList from './providerListsAccordion';

const Assign = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const { clientId } = useParams();

	const therapists = useSelector((state) => state.userClient.therapists);
	const clientInfo = useSelector((state) => state.client.client);

	useEffect(() => {
		if (Boolean(therapists) || !clientId) return;
		dispatch(getTherapists({ clientId }));
	}, [clientId, therapists, dispatch]);

	useEffect(() => {
		if (!clientId) return;
		if (clientInfo.id === clientId) return;
		dispatch(getClient(clientId));
	}, [clientId, clientInfo.id, dispatch]);

	return (
		<Container style={{ position: 'relative' }}>
			<div
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					flexWrap: 'wrap',
				}}
				className="marginBottom16"
			>
				<Text title={`Assign Providers for ${clientInfo.fullName}`} type="h1" font="header" fontWeight="semiBold" />
				<DefaultBCBA />
			</div>
			{screenWidth > 768 ? <ProviderLists /> : <AccordionList />}
			<SaveChanges />
		</Container>
	);
};

export default Assign;
